import React, {useEffect, useState} from 'react'
import {useParams, useNavigate} from 'react-router-dom'
import './NewsletterUnsubscribe.scss'
import NewsletterService from 'src/services/NewsletterService'
import UnsubscribeForm from '../../components/UnsubscribeForm'

const NewsletterUnsubscribe = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME
  const root = document.getElementById('root')
  root.classList.add('black-bck')

  let params = useParams()
  const navigate = useNavigate()
  const [subscriberEmail, setSubscriberEmail] = useState('')

  const [dataFromChild, setDataFromChild] = useState(true)
  const service = {
    newsletter: new NewsletterService()
  }

  useEffect(() => {
    if (params.sf) {
      const payload = {
        param: params.sf
      }
      service.newsletter.retrieveSubscriber(payload).then((resp: any) => {
        if (!resp.error) {
          setSubscriberEmail(resp.retrieved_email)
          document.title = companyName + ' - unsubscribe ' + resp.retrieved_email
        }
      }).catch(error => {
        navigate('/')
      })
    } else {
      navigate('/')
    }
  }, [])

  const handleDataFromChild = (bool) => {
    setDataFromChild(bool)
  }

  return (
    <section className="newsletter-unsubscribe black-bck white">
      <div className="section-heading">
        <div className="container">
          <h1>Unsubscribe</h1>
          <div className="section-description">
            Are you sure you want to say goodbye?
          </div>
        </div>
      </div>
      <div className="container">
        <UnsubscribeForm emailSubscriber={subscriberEmail} />
      </div>
    </section>
  )
}

export default NewsletterUnsubscribe